export default __webpack_public_path__ + "static/media/phone-icon.f74f2696.svg";